import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import RadioGroupCommon from '../../../CommonV2/RadioGroup';

const FieldRadioGroup = ({
  code,
  disabled,
  selection,
  validate,
  existError,
  showError,
  nowrap,
  handleChange,
  blockId,
}) => (
  <Field
    component={RadioGroupCommon}
    name={code}
    disabled={disabled}
    selection={selection}
    existError={existError}
    showError={showError}
    validate={validate}
    nowrap={nowrap}
    eventEmitter={v => handleChange(v)}
    blockId={blockId}
  />
);

FieldRadioGroup.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  selection: PropTypes.array.isRequired,
  validate: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  nowrap: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  blockId: PropTypes.string,
};
FieldRadioGroup.defaultProps = {
  disabled: false,
  nowrap: false,
  blockId: '',
};
export default connect(FieldRadioGroup);
